import { Typography, List, ListItem, ListItemText, ListItemButton, Box } from '@mui/material';
import React from 'react';
import MenuItem from '../models/MenuItem';

interface MenuProps {
    menuItems : MenuItem[]
}

const MenuBar: React.FC<MenuProps> = (props) => {
    return (
        <Box className='MenuFrame' sx={{height: '4vmax', minWidth: '500px', display: 'flex', justifyContent: 'center', alignItems:'center'}}>
            <Box className='MenuTextBox'>
                <List>
                    <ListItem sx={{listStyle: 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        {props.menuItems.map((menuItem: MenuItem, index: React.Key | null | undefined) => ( 
                            <ListItemButton key={index} onClick={menuItem.redirectTo}>
                                <ListItemText key={index} sx={{minWidth: '80px'}}>
                                    <Typography fontFamily={'Georgia'} color={'#f2e9e2'} fontSize={25} variant='h6' sx={{whiteSpace: 'nowrap'}}>{menuItem.label}</Typography>
                                </ListItemText>
                            </ListItemButton>
                        ))}
                    </ListItem>
                </List>
           </Box>
        </Box>
    );
};

export default MenuBar;